import React from 'react';
import { Github, Linkedin, Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="py-16 px-4 md:px-8 border-t border-zinc-800/50 w-full">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col items-center justify-center space-y-8">
          {/* Large social links */}
          <div className="flex justify-center items-center w-full gap-8">
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 text-zinc-400 hover:text-purple-400 transition-all duration-300"
            >
              <div className="p-4 rounded-xl bg-zinc-900/40 border border-zinc-800 group-hover:border-purple-500/50 group-hover:bg-zinc-800/50 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-purple-500/20">
                <Github className="w-8 h-8" />
              </div>
              <span className="text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:visible">
                GitHub
              </span>
            </a>

            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 text-zinc-400 hover:text-cyan-400 transition-all duration-300"
            >
              <div className="p-4 rounded-xl bg-zinc-900/40 border border-zinc-800 group-hover:border-cyan-500/50 group-hover:bg-zinc-800/50 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-cyan-500/20">
                <Linkedin className="w-8 h-8" />
              </div>
              <span className="text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:visible">
                LinkedIn
              </span>
            </a>

            <a
              href="mailto:contact@example.com"
              className="group flex items-center gap-3 text-zinc-400 hover:text-purple-400 transition-all duration-300"
            >
              <div className="p-4 rounded-xl bg-zinc-900/40 border border-zinc-800 group-hover:border-purple-500/50 group-hover:bg-zinc-800/50 transition-all duration-300 group-hover:shadow-lg group-hover:shadow-purple-500/20">
                <Mail className="w-8 h-8" />
              </div>
              <span className="text-lg font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300 hidden md:visible">
                Email
              </span>
            </a>
          </div>

          {/* Copyright */}
          <div className="text-center text-zinc-500 text-sm">
            <p>© 2026 Warren Jonas. All rights reserved.</p>
            <p className="mt-2">Built with React & TailwindCSS</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
